import { useEffect, useMemo } from 'react';
import { type FormConfig, type FormValues, type OnChange } from '../../types';
import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { deepEqual } from 'fast-equals';
import { fillEmptyValues } from '../form-values';
import { normalizeValues } from './normalize-values';

export const useFormValues = (
  form?: Form,
  values?: FormValues,
  onChange?: OnChange,
  config?: FormConfig | null,
): FormValues => {
  const normalizedValues = useMemo(
    () => normalizeValues(form, fillEmptyValues(form, values), true, config),
    [form, values, config],
  );
  useEffect(() => {
    const hasAnyValueChanged = !deepEqual(normalizedValues, values);
    if (hasAnyValueChanged) {
      onChange?.(normalizedValues);
    }
  }, [values, normalizedValues, onChange]);

  return normalizedValues;
};
